/** «Посты ВК» — ровно то, что отдаёт `GET /api/vk/posts`. Пустое значение — ВК ещё не отдал. */
import { apiFetch, query } from "@/lib/api";

export type VkPostRow = {
  post_id: number;
  url: string;
  /** Когда вышел, MSK, `ГГГГ-ММ-ДДTЧЧ:ММ`. */
  date: string;
  kind: string;
  kind_label: string;
  /** `vk` — выложен руками, `api` — планировщиком. */
  source: string;
  text: string;
  /** Уникальные люди; у клипа — лента клипов. */
  reach: number | null;
  reach_subscribers: number | null;
  reach_viral: number | null;
  viral_share: number | null;
  views: number | null;
  likes: number | null;
  reposts: number | null;
  comments: number | null;
  to_group: number | null;
  links: number | null;
  joins: number | null;
  hides: number | null;
  /** Охват на 2-й и 7-й день жизни поста — по снимкам. */
  reach_2d: number | null;
  reach_7d: number | null;
  stat_date: string | null;
};

export type VkTotal = {
  posts: number;
  reach: number;
  reach_subscribers: number;
  reach_viral: number;
  viral_share: number | null;
  reach_avg: number | null;
  views: number;
  likes: number;
  reposts: number;
  comments: number;
  to_group: number;
  links: number;
  joins: number;
  hides: number;
};

export type VkDay = {
  day: string;
  posts?: number;
  visitors?: number;
  visits?: number;
  subscribers?: number;
  posts_reach?: number;
  clips_reach?: number;
};

export type VkPosts = {
  from: string;
  to: string;
  stat_date: string | null;
  total: VkTotal;
  kinds: (VkTotal & { kind: string; label: string })[];
  rows: VkPostRow[];
  days: VkDay[];
};

export function loadVkPosts(from: string, to: string): Promise<VkPosts> {
  return apiFetch<VkPosts>(`/api/vk/posts${query({ from, to })}`);
}
